export const getHighestHubPlan = (ownedProducts, hub) => {
  if (!ownedProducts) {
    ownedProducts = [];
  }
  let highestLevel = 'free';
  ['starter', 'pro', 'enterprise'].forEach(priceLevel => {
    if (ownedProducts.includes(hub === 'marketing' ? `marketing-${priceLevel}` : `${hub}-${priceLevel}-bundle`)) {
      highestLevel = priceLevel;
    }
  });
  return highestLevel;
};
export const getAnnualDiscountPercentage = ({
  discounts,
  hub,
  pricingLevel
}) => {
  var _discounts$productsEl;
  if (!discounts) return 0;
  const promotions = discounts === null || discounts === void 0 || (_discounts$productsEl = discounts.productsEligibleForDirectPromotions) === null || _discounts$productsEl === void 0 ? void 0 : _discounts$productsEl[`${hub}-hub-${pricingLevel === 'pro' ? 'professional' : pricingLevel}`];
  const promotion = Object.values(promotions || {})[0];
  const annualDiscountOfferId = promotion && promotion.offerIds.find(offerId => {
    const offer = discounts.offersById[offerId];
    return offer.commitmentTerm === 'ANNUAL' && offer.paymentTerm === 'ANNUAL';
  });
  const annualDiscountPercentage = annualDiscountOfferId && discounts.offersById[annualDiscountOfferId].discount;
  return annualDiscountPercentage || 0;
};
export const getPriceForProduct = ({
  hubPricingData,
  hub,
  pricingLevel,
  selectedCurrency,
  annualDiscountPercentage
}) => {
  var _hubPricingData$hub;
  const basePrice = (hubPricingData === null || hubPricingData === void 0 || (_hubPricingData$hub = hubPricingData[hub]) === null || _hubPricingData$hub === void 0 || (_hubPricingData$hub = _hubPricingData$hub[pricingLevel]) === null || _hubPricingData$hub === void 0 ? void 0 : _hubPricingData$hub[selectedCurrency]) || null;
  if (basePrice === null) return null;
  const finalPrice = annualDiscountPercentage ? Math.ceil(basePrice * (1 - annualDiscountPercentage / 100)) : basePrice;
  return finalPrice;
};